import {isEmpty} from "underscore";

export const isEmptyHTML = (text) => {
  const clean = text?.replace(/(<([^>]+)>)/ig, "")
    .replace(/&nbsp;/ig, "")
    .replace(/\s/g, "");

  return clean === "" || isEmpty(clean);
};
